import React from 'react';
import Router from './router';
import {Provider} from 'react-redux';
import {store} from './store'

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'react-confirm-alert/src/react-confirm-alert.css';

import './modules/metajson-sub/src/static/css/bootstrap.css';
import './modules/metajson-sub/src/static/css/bootstrap-multiselect.css'
import './modules/metajson-sub/src/static/css/styles.css';
import './modules/metajson-sub/src/static/css/adaptive.css';
import './modules/metajson-sub/src/static/css/custom.css';
import './modules/metajson-sub/src/static/css/circle.css';
import './modules/metajson-sub/src/static/css/fonts.css';
import './modules/metajson-sub/src/static/css/swiper.css';
import './modules/metajson-sub/src/static/css/react-select.css';
import './modules/metajson-sub/src/static/css/app.css';
import './modules/metajson-sub/src/static/css/content.css';
import './modules/metajson-sub/src/static/css/selectblock.css';
import './modules/metajson-sub/src/static/css/dots.css';

class App extends React.Component {
  render = () => (
    <Provider store={store}>
      <Router />
    </Provider>
  )
}

export default App;
